import { render, staticRenderFns } from "./TotalInstalment.vue?vue&type=template&id=80774082"
import script from "./TotalInstalment.vue?vue&type=script&lang=js"
export * from "./TotalInstalment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports